module.exports = __webpack_public_path__ + "static/003-0dd4b79143cc472c965c00e4f344fc49.jpg";